import i18n from './index';
import { fixedUi } from './fixedUi';

function localizeChartFallback(text, options) {
  if (text == null || typeof text !== 'string') return text;
  return fixedUi(text, options);
}

/** 模块级校验和弹窗里用：未初始化时返回中文原文。 */
export function chartText(key, fallback, options) {
  if (!i18n.isInitialized) return localizeChartFallback(fallback, options);
  const raw = i18n.t(key, { ns: 'workbench', defaultValue: fallback, ...(options || {}) }) || fallback;
  return localizeChartFallback(raw, options);
}

/** 下拉展示用。value 仍是平台码，只替换 label。 */
export function localizeOptions(options, keyByValue) {
  return (options || []).map((opt) => {
    const key = keyByValue?.[String(opt.value)];
    if (!key) return opt;
    return { ...opt, label: chartText(key, opt.label) };
  });
}

export function optionLabel(options, keyByValue, value, fallback) {
  const hit = (options || []).find((opt) => String(opt.value) === String(value));
  if (!hit) return fallback;
  const key = keyByValue?.[String(hit.value)];
  return key ? chartText(key, hit.label) : hit.label;
}
